/**
 * @deprecated The `list` variant describes the change better, `ol` `li`. The component always renders a `nav`.
 *
 * BEFORE variant="nav"
 * AFTER variant="list"
 * @deprecatedSince 11.33.0
 * @since 11.6.0
 */
export var BreadcrumbVariants = /*#__PURE__*/function (BreadcrumbVariants) {
  BreadcrumbVariants["NAV"] = "nav";
  BreadcrumbVariants["LEGACY"] = "legacy";
  return BreadcrumbVariants;
}({});
//# sourceMappingURL=Breadcrumbs.types.js.map